import React from 'react';
import { withRouter } from 'react-router-dom';
import SmartForm from '../../common/libs/SmartForm';
import _ from 'lodash';
import { Avatar, Button, Paper, Typography, withStyles } from '@material-ui/core';
import { Loader, showError } from '../libs/helpers';
import { DataApi } from '../../../providers/api-provider';
import styles from './styles/quick-volunteer-log';
import { AppConfig } from '../../../config/app';

class QuickVolunteerLog extends React.Component {
    state = {
        loading: true,
        invalid: false,
        done: false,
        fields: [
            {
                name: 'donor_to_id',
                required: false,
                type: 'select',
                width: 12,
                title: 'Student (Optional)',
            },
            {
                name: 'topic_discussed',
                required: false,
                type: 'text',
                width: 12,
                title: 'What was the topic/s discussed during this session?',
                hidden: function () { return !this.state.form.donor_to_id }
            },
            {
                name: 'timer_type',
                required: false,
                type: 'switch',
                width: 12,
                value: 'fixed_time',
                //title: 'Fixed or stop watch',
                data: [{ id: 'fixed_time', name: 'Fixed Date/Time' }, { id: 'stopwatch', name: 'Stop Watch' }]
            },
            {
                name: 'period_stopwatch',
                required: false,
                type: 'stopwatch',
                width: 12,
                // title: 'Hours',
                hidden: function () { return this.state.form.timer_type === 'fixed_time' }
            },
            {
                name: 'period',
                required: false,
                type: 'number',
                width: 4,
                title: 'Hours',
                hidden: function () { return this.state.form.timer_type === 'stopwatch' }
            },
            {
                name: 'started_at',
                required: false,
                type: 'date',
                width: 4,
                title: 'From',
                hidden: function () { return this.state.form.timer_type === 'stopwatch' }
            },
            {
                name: 'ended_at',
                required: false,
                type: 'date',
                width: 4,
                title: 'To',
                hidden: function () { return this.state.form.timer_type === 'stopwatch' }
            },
            {
                name: 'category_id',
                required: false,
                type: 'hidden',
                data: 'categories',
                width: 12,
                title: 'Category',
                value: 1,
            },
            {
                name: 'category_other',
                required: false,
                type: 'hidden',
                width: 12,
                title: 'Category (Other)',
                hidden: function () { return this.state.form.category_id !== 'other' }
            },
            {
                name: 'description_private',
                required: false,
                type: 'textarea',
                width: 12,
                title: 'Detailed Description (Private - only you and program manager)',
                hidden: function () { return !this.state.form.donor_to_id }
            },
            {
                name: 'description',
                required: false,
                type: 'textarea',
                width: 12,
                title: <Typography>Short Description (<span className='color-blue'>Public</span> - shown in Student's Campaign Page if they have a campaign)</Typography>,
            },
            {
                name: 'rate_session',
                required: false,
                type: 'select',
                width: 3,
                title: 'Session Rate',
                data: [{ id: '0', name: "Not Good" }, { id: "1", name: "Satisfactory" }, { id: "2", name: "Great" }],
                hidden: function () { return !this.state.form.donor_to_id },
            },
            {
                name: 'faced_difficulties_session',
                required: false,
                type: 'select',
                width: 9,
                title: 'Have you faced a challenge on the call? do you need support?',
                data: [{ id: '0', name: "No" }, { id: "1", name: "Yes" }],
                hidden: function () { return !this.state.form.donor_to_id },
            },
            {
                name: 'description_difficulties',
                required: false,
                type: 'textarea',
                width: 12,
                title: 'Describe the challenges below please',
                hidden: function () { return !this.state.form.donor_to_id || this.state.form.faced_difficulties_session !== '1' },
            },
            {
                name: 'donor_to_type',
                type: 'hidden',
                value: 'student',
            },
        ]

    }
    /*
   -----------------------------------------------------------------------
   API Functions
   -----------------------------------------------------------------------
   */
    fetchLogData = async () => {
        try {
            const res = await DataApi.getOne('/quick-volunteer-log/' + this.props.match.params.secret);
            const state = { loading: false };
            if (res.data.invalid)
                state.invalid = res.data.invalid
            else {
                state.fields = _.cloneDeep(this.state.fields);
                state.fields[0].data = res.data.mentees;
            }
            this.setState(state);
        } catch (e) {
            const message = showError(e);
            this.setState({ loading: false, invalid: message, });
        }
    }
    componentDidMount() {
        this.fetchLogData();
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */

    renderForm = () => {
        const { fields, loading, invalid, done } = this.state;
        if (loading)
            return (<div className="allpadding-lg"><Loader /></div>);
        if (invalid)
            return (
                <div className=" bmargin-sm">
                    <Typography color="secondary">
                        {invalid}
                    </Typography>
                </div>
            );
        if (done)
            return (
                <div >
                    <Typography color="primary" className=" bmargin-sm tmargin-lg">
                        Thank you! feedback has been saved successfully.
                </Typography>
                    <Button color="primary" variant="contained" onClick={() => this.setState({ done: false })}>Add another log</Button>
                </div>
            );
        return (
            <div>
                <Typography className="bmargin-lg">
                    This is a confidential form that will only be shared with P2P's program manager.
                    Only specific field (Short Description) which support students' campaigns may be published in 
                    student public campaign for example check out the Backers section <a href="https://www.edseed.me/campaigns/e-learning-is-the-way-of-the-future-i-and-syrias-children-want-to-be-part-of-it/" target="_blank">here</a> for one of our students public campaign and scroll down to Ayham's comment.
                </Typography>
                <SmartForm fields={fields}
                    actionUrl={'/quick-volunteer-log/' + this.props.match.params.secret}
                    redirect={false}
                    onFormSaved={() => this.setState({ done: true })}
                    buttonTitle='Add'
                    rebuildOnUpdate={true}
                    noPaper
                    actionType='create' />
            </div>
        )
    }
    render() {
        const { classes } = this.props;
        return (
            <main className={classes.layout} >
                <Paper className={classes.paper} style={{ backgroundColor: '#ffffffe6' }}>
                    <Avatar className={classes.avatar}>
                        <img alt='edSeed Logo' src={AppConfig.base + '/logo.png?v1'} style={{ width: '95%' }} />
                    </Avatar>
                    <Typography component="h1" variant="h5" style={{ width: '100%' }}>
                        P2P Mentorship Program Feedback
                </Typography>
                    {this.renderForm()}
                </Paper>
            </main>
        )
    }
}


export default withRouter(withStyles(styles)(QuickVolunteerLog));

